import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string'
import { LOAD_CABIN_CREW_FOR_SCHEDULING, GET_CABIN_CREW_FOR_SCHEDULING, CLEAR_CABIN_CREW_FOR_SCHEDULING } from "../types";
import {
  DEFAULT_GET_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { CABIN_CREW_FOR_SCHEDULING_ENDPOINT } from '../../config/endpoints';


const loadCabinCrewForScheduling = (status) => (dispatch) =>
  dispatch({
    type: LOAD_CABIN_CREW_FOR_SCHEDULING,
    payload: status,
  });

const getCabinCrewForScheduling = ({ fromDateString, toDateString, itineraryDirection, homeBaseLocationId, serviceTypes, showNorteChico }) => async (dispatch) => {
  try {
    dispatch(loadCabinCrewForScheduling(true));
    const url = `${CABIN_CREW_FOR_SCHEDULING_ENDPOINT}?${QueryString.stringify({ fromDateString, toDateString, itineraryDirection, homeBaseLocationId, serviceTypes, showNorteChico })}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const schedulingData = await response.json();
    dispatch({
      type: GET_CABIN_CREW_FOR_SCHEDULING,
      payload: schedulingData,
    });
  } catch (error) {
    toastr.error('Error', 'Failed to fetch cabin crew scheduling data');
  } finally {
    dispatch(loadCabinCrewForScheduling(false));
  }
};

const clearCabinCrewForScheduling = () => (dispatch) =>
  dispatch({
    type: CLEAR_CABIN_CREW_FOR_SCHEDULING,
  });

const exportCabinCrewForSchedulingFile = async (formValues) => async (dispatch) => {
  try {
    dispatch(loadCabinCrewForScheduling(true));
    const url = `${CABIN_CREW_FOR_SCHEDULING_ENDPOINT}/export?${QueryString.stringify(
      formValues,
    )}`;
    const response = await fetch(url, {
      ...DEFAULT_GET_CONFIG,
    });
    await isErrorResponse(response, null, dispatch);
    const blob = await response.blob();
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'CabinCrewForScheduling.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    toastr.error('Error', 'Failed to export cabin crew scheduling data');
  } finally {
    dispatch(loadCabinCrewForScheduling(false));
  }
}


export { loadCabinCrewForScheduling, getCabinCrewForScheduling, clearCabinCrewForScheduling, exportCabinCrewForSchedulingFile }